import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { TextInput, NumberInput } from '@ztechapps/webui.input'
import { StatusSelect } from '@ztechapps/webui.data-tools'
import { Col, Row } from 'react-bootstrap'
import { UnitOfMeasureCategorySelect } from '../select/UnitOfMeasureCategorySelect'

export const UnitOfMeasureAddFormInput = () => {
  return (
    <Row className="g-3">
      <Col md={6}>
        <Field label="Code" name="code" component={TextInput} />
      </Col>
      <Col md={6}>
        <Field label="Name" name="name" component={TextInput} />
      </Col>
      <Col md={6}>
        <Field label="Symbol" name="symbol" component={TextInput} />
      </Col>
      <Col md={6}>
        <Field label="Category" name="category" component={UnitOfMeasureCategorySelect} onChange isClearable={false} />
      </Col>
      <Col md={6}>
        <Field label="Conversion Factor" name="conversionFactor" component={NumberInput} />
      </Col>
      <Col md={6}>
        <Field label="Status" name="status" component={StatusSelect} onChange isClearable={false} />
      </Col>
    </Row>
  )
}
